import { FilePreviewType } from '@baserow/modules/database/filePreviewTypes'
import PreviewWordMG from '@extras_mg/components/PreviewWordMG.vue'

export class WordMGFilePreview extends FilePreviewType {
  static getType() {
    return 'word-mg'
  }

  getName() {
    return 'Word'
  }

  isCompatible(mimeType) {
    return mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  }

  getPreviewComponent() {
    return PreviewWordMG
  }
}
